import { Form, Row, Col, Input, Select } from 'antd';
import React from 'react';

interface PropList {
  listPro: any;
}
const { Option } = Select;

const ProductDelivery = ({ listPro }: PropList) => {
  return (
    <div className="wrapDelivery">
      {listPro.map((item: any) => (
        <div className="proDelivery">
          {' '}
          <Form
            layout="vertical"
            initialValues={{
              productName: item.productName,
              sku: item.sku,
              eanUpc: item.eanUpc,
              quantity: item.quantity
            }}
          >
            <Row className="rowDeliver">
              <Col span={10}>
                <Form.Item label="Product Name" name="productName">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="SKU" name="sku">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label="EAN/UPC" name="eanUpc">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label="Quantity" name="quantity">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      ))}
    </div>
  );
};

export default ProductDelivery;
